(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-daily-serving"] && !Shopify.designMode) return;
  try {
    
(function () {
  function connectGuide(root) {
    if (root.dataset.connected === 'true') return;
    root.dataset.connected = 'true';
    var inputs = Array.from(root.querySelectorAll('.lm-dose__options input'));
    function buyWeights() { return Array.from(document.querySelectorAll('#buy-form [data-weight]')); }
    function sync() {
      var index = buyWeights().findIndex(function (button) { return button.getAttribute('aria-checked') === 'true'; });
      if (inputs[index]) inputs[index].checked = true;
    }
    inputs.forEach(function (input, index) {
      input.addEventListener('change', function () {
        var button = buyWeights()[index];
        if (input.checked && button && button.getAttribute('aria-checked') !== 'true') button.click();
      });
    });
    document.addEventListener('betterdog:selection-change', function (event) {
      var input = inputs[event.detail.weight - 1];
      if (root.isConnected && input) input.checked = true;
    });
    sync();
  }
  function init() { document.querySelectorAll('[data-serving-guide]').forEach(connectGuide); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-home-quiz"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bd-home-quiz-tracker')){
  customElements.define('bd-home-quiz-tracker',class extends HTMLElement{
    connectedCallback(){
      const section=this.closest('.bd-home-quiz');
      const link=section?.querySelector('[data-home-quiz-link]');
      if(!link || link.dataset.trackingBound)return;
      link.dataset.trackingBound='true';
      const incoming=new URLSearchParams(window.location.search);
      const destination=new URL(link.href);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','msclkid','bd_debug'].forEach(key=>{
        if(incoming.has(key))destination.searchParams.set(key,incoming.get(key));
      });
      link.href=destination.href;
      link.addEventListener('click',()=>{
        try{
          if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===false)return;
          const published=window.Shopify?.analytics?.publish('betterdog_home_quiz_clicked',{quiz_entrypoint:'homepage_section'});
          if(published?.catch)published.catch(()=>{});
        }catch(_){}
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-info-ticker"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('.bd-ticker__toggle');
  if(!button)return;
  const ticker=button.closest('.bd-ticker');
  const paused=ticker.dataset.paused!=='true';
  ticker.dataset.paused=String(paused);
  button.setAttribute('aria-pressed',String(paused));
  button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-ingredient-spotlight"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('.bd-ingredients').forEach(function(section){
      if(section.dataset.carouselReady)return;
      section.dataset.carouselReady='true';
      var track=section.querySelector('.bd-ingredients__grid');
      var prev=section.querySelector('[data-ingredient-prev]');
      var next=section.querySelector('[data-ingredient-next]');
      if(!track||!prev||!next)return;
      var frame=section.querySelector('.bd-ingredients__carousel');
      var motion=matchMedia('(prefers-reduced-motion: reduce)');
      var paused=motion.matches;
      var visible=false;
      var lastInteraction=0;
      var originals=Array.from(track.children);
      var copies=originals.length;
      function clone(card){
        var copy=card.cloneNode(true);
        copy.setAttribute('aria-hidden','true');
        copy.removeAttribute('id');
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id')});
        return copy;
      }
      originals.forEach(function(card){track.appendChild(clone(card))});
      var before=document.createDocumentFragment();
      originals.forEach(function(card){before.appendChild(clone(card))});
      track.prepend(before);
      function cycleWidth(){
        return track.children[copies*2].offsetLeft-track.children[copies].offsetLeft;
      }
      function startPosition(){
        return track.children[copies].offsetLeft-track.children[0].offsetLeft;
      }
      function jump(left){
        track.style.scrollSnapType='none';
        track.scrollTo({left:left,behavior:'instant'});
        requestAnimationFrame(function(){track.style.scrollSnapType=''});
      }
      function normalize(){
        var width=cycleWidth(),start=startPosition();
        if(!width)return;
        if(track.scrollLeft<start-1)jump(track.scrollLeft+width);
        else if(track.scrollLeft>=start+width-1)jump(track.scrollLeft-width);
      }
      var settle;
      function update(){
        prev.disabled=false;
        next.disabled=false;
        frame.dataset.moreLeft='true';
        frame.dataset.moreRight='true';
        clearTimeout(settle);
        settle=setTimeout(normalize,180);
      }
      function move(direction){
        var card=track.querySelector('.bd-ingredient');
        if(!card)return;
        var step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      prev.addEventListener('click',function(){move(-1)});
      next.addEventListener('click',function(){move(1)});
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',function(event){
        if(event.target!==track)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}
      });
      var oldWidth=0;
      new ResizeObserver(function(){if(track.clientWidth!==oldWidth){oldWidth=track.clientWidth;jump(startPosition())}update()}).observe(track);
      ['pointerdown','wheel','keydown'].forEach(function(name){section.addEventListener(name,function(){lastInteraction=Date.now()},{passive:true})});
      new IntersectionObserver(function(entries){visible=entries[0].isIntersecting},{threshold:.5}).observe(track);
      motion.addEventListener('change',function(){paused=motion.matches});
      var timer=setInterval(function(){
        if(!section.isConnected){clearInterval(timer);return}
        if(paused||motion.matches||!visible||document.hidden||section.matches(':hover')||section.contains(document.activeElement)||Date.now()-lastInteraction<10000)return;
        move(1);
      },10000);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bd-matrix"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.lm-story__link, .lm-spotlight__link');
    if (!link) return;
    if (link.getAttribute('href') !== '#ingredients') return;
    const label = document.querySelector('#ingredients > details');
    if (label) label.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dog-support-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dog-support-quiz')) {
  customElements.define('dog-support-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.step = 0;
      this.form = this.querySelector('form');
      this.track('betterdog_quiz_viewed');
      this.form.addEventListener('change', () => { if(!this.started){this.started=true;this.track('betterdog_quiz_started');} });
      this.querySelector('.bdq__product .bdq__button').addEventListener('click',()=>this.track('betterdog_quiz_product_clicked'));
      const buy = this.querySelector('.bdq__product .bdq__button');
      const destination = new URL(buy.href);
      const incoming = new URLSearchParams(window.location.search);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','msclkid'].forEach(key => {
        if(incoming.has(key)) destination.searchParams.set(key,incoming.get(key));
      });
      destination.searchParams.set('quiz_source','tailored_recommendation');
      buy.href = destination.href;
      this.querySelectorAll('[data-result-product-link]').forEach(link => {
        link.href = destination.href;
        link.addEventListener('click', () => this.track('betterdog_quiz_product_clicked'));
      });
      this.querySelector('[data-next]').addEventListener('click', () => {
        const valid = this.querySelector('input[name="need"]:checked');
        this.querySelector('[data-error="0"]').hidden = !!valid;
        if (valid) { this.track('betterdog_quiz_needs_completed'); this.showStep(1); }
      });
      this.querySelector('[data-back]').addEventListener('click', () => this.showStep(0));
      this.querySelector('[data-priority-back]').addEventListener('click', () => this.showStep(1));
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if(this.step === 3) return;
        if(this.step === 0) { this.querySelector('[data-next]').click(); return; }
        if(this.step !== 1 && this.step !== 4) return;
        const age = this.querySelector('input[name="age"]:checked');
        this.querySelector('[data-error="1"]').hidden = !!age;
        if (!age) return;
        if(this.step === 1) { this.track('betterdog_quiz_age_completed'); this.showStep(4); return; }
        const priority = this.querySelector('input[name="priority"]:checked');
        this.querySelector('[data-error="4"]').hidden = !!priority;
        if(!priority) return;
        this.querySelectorAll('[data-priority-result]').forEach(el => { el.hidden = el.dataset.priorityResult !== priority.value; });
        this.track('betterdog_quiz_priority_completed');
        const needs = [...this.querySelectorAll('input[name="need"]:checked')].map(input => input.value);
        const selectedBenefits = this.querySelector('[data-selected-benefits]');
        const otherBenefits = this.querySelector('[data-other-benefits]');
        const otherSupport = this.querySelector('[data-other-support]');
        const benefitCards = [...this.querySelectorAll('[data-benefit]')].sort((a,b) => ['joint','gut','skin','immune','energy','aging'].indexOf(a.dataset.benefit) - ['joint','gut','skin','immune','energy','aging'].indexOf(b.dataset.benefit));
        benefitCards.forEach(card => {
          card.hidden = false;
          (needs.includes(card.dataset.benefit) ? selectedBenefits : otherBenefits).append(card);
        });
        const otherCount = otherBenefits.children.length;
        const otherLabel = this.querySelector('[data-other-label]');
        otherLabel.textContent = (otherCount === 1 ? otherLabel.dataset.singular : otherLabel.dataset.plural).replace('[count]',otherCount);
        otherSupport.hidden = otherCount === 0;
        otherSupport.open = false;
        this.querySelectorAll('[data-support-tag]').forEach(tag => { tag.hidden = !needs.includes(tag.dataset.supportTag); });
        this.querySelectorAll('[data-life]').forEach(card => { card.hidden = card.dataset.life !== age.value; });
        this.showStep(3);
        this.loadingTimer = setTimeout(() => { this.showStep(2); this.track('betterdog_quiz_completed'); }, 2000);
      });
      this.querySelector('[data-restart]').addEventListener('click', () => {
        this.form.reset();
        this.started = false;
        this.track('betterdog_quiz_restarted');
        this.querySelectorAll('[data-error]').forEach(el => { el.hidden = true; });
        this.showStep(0);
      });
    }
    track(name) {
      try {
        if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) return;
        const needs = [...this.querySelectorAll('input[name="need"]:checked')].map(input => input.value).sort();
        const payload = {
          quiz_version:'3',
          selected_count:needs.length,
          quiz_concerns:needs.join('|'),
          quiz_age:this.querySelector('input[name="age"]:checked')?.value || 'not_answered',
          quiz_priority:this.querySelector('input[name="priority"]:checked')?.value || 'not_answered'
        };
        const published = window.Shopify?.analytics?.publish(name,payload);
        if(published?.catch) published.catch(()=>{});
      } catch (_) {}
    }
    disconnectedCallback() { clearTimeout(this.loadingTimer); }
    showStep(step) {
      this.step = step;
      const eyebrow = this.querySelector('.bdq__eyebrow');
      eyebrow.hidden = step === 3;
      eyebrow.textContent = step === 2 ? 'The results are in' : step === 4 ? eyebrow.dataset.lastLabel : eyebrow.dataset.defaultLabel;
      this.querySelector('.bdq__progress').hidden = step === 3;
      this.querySelectorAll('[data-step]').forEach(panel => { panel.hidden = Number(panel.dataset.step) !== step; });
      this.querySelectorAll('.bdq__progress span').forEach((bar,index) => bar.classList.toggle('is-current',index <= (step === 0 ? 0 : step === 1 ? 1 : 2)));
      const heading = this.querySelector('[data-step="' + step + '"] h1, [data-step="' + step + '"] h2');
      heading.focus({preventScroll:true});
      this.scrollIntoView({behavior:'instant',block:'start'});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
